<template>
	<div class="row d-flex justify-content-center text-center">
		<div class="col-12">
			<div class="h5">
				Válassz ügyfelet
			</div>
		</div>
		<div class="col-12 col-sm-12 col-md-8">
			<form :submit.prevent="load">
				<div class="row d-flex">
					<div class="col-12 col-md-3">
						<div class="mui-textfield text-center">
				    		<input type="text" v-model="search.nev">
				    		<label>Név</label>
				  		</div>
					</div>
					<div class="col-12 col-md-3">
						<div class="mui-textfield text-center">
				    		<input type="text" v-model="search.city">
				    		<label>Város</label>
				  		</div>
					</div>
					<div class="col-12 col-md-3">
						<div class="mui-textfield text-center">
				    		<input type="text" v-model="search.street">
				    		<label>Utca</label>
				  		</div>
					</div>
					<div class="col-12 col-md-2">
						<button
							class="btn btn-primary"
							@click.prevent="load"
							type="submit"
						>
							Keresés
						</button>
					</div>
				</div>
			</form>
		</div>
		<div class="col-12 mt-2 mb-2">
			<span class="font-weight-bold h4 text-danger">
				Piros háttérrel kiemelve az INAKTÍV ügyfelek!!
			</span>
		</div>
		<div class="col-12 align-items-center" v-if="isLoading">
			<div class="spinner-grow" style="width: 3rem; height: 3rem;" role="status"></div>
			<span>Betöltés...</span>
		</div>
		<div class="col-12" v-if="customers&&customers.length>0">
			<div class="table-wrapper">
				<table class="table table-hover">
			        <thead class="sticky-top bg-light">
			          	<tr>
				          	<th scope="col">#</th>
				          	<th scope="col">Státusz</th>
				            <th scope="col">Név</th>
				            <th scope="col">Régió</th>
				            <th scope="col">Város</th>
				            <th scope="col">Cím</th>
				            <th scope="col">BillingoID</th>
				            <th scope="col">#</th>
			          	</tr>
			        </thead>
			        <tbody>
			          	<tr
				          	v-for="(item,index) in customers"
				          	:key="index"
				          	:class="[item.aktiv == 0 ? 'table-danger' : '']"
			          	>
				          	<td>
				          		<button
				          			class="btn btn-outline-primary"
				          			@click.prevent="$store.dispatch('setrendselcustomer',item)"
				          		>
				          			Kiválaszt
				          		</button>
				          	</td>
				          	<td>
				          		<span
				          			class="font-weight-bold"
				          			v-if="item.aktiv == 0"
				          		>
				          			NEM AKTÍV
				          		</span>	
				          	</td>
				            <td>{{item.nev}}</td>
				            <td>{{item.regio}}</td>
				            <td>{{item.varos}}</td>
				            <td>{{item.cim}}</td>
				            <td>{{item.billingo_id}}</td>
				            <td>
				            	<router-link
				                	:to="`/customer/${item.uszam}`" target="_blank"
				              	>
				                  	<button class="btn btn-outline-primary">
				                      	Módosít
				                  	</button>
				              	</router-link>
          					</td>
			          	</tr>
			        </tbody>
			    </table>
			</div>
		</div>
		
		<div class="col-12 col-md-8 mt-2 mb-2" v-if="customers&&customers.length==0">
			<div class="alert alert-info">
				<p class="h5">
					Nincs találat
				</p>
			</div>
		</div>
		<div class="col-10 mt-2 mb-2" v-if="rend_sel_customer&&rend_sel_customer.szamlazva!=0">
			<div class="alert alert-danger h4">
				Ennek az ügyfélnek {{ rend_sel_customer.szamlazva | huf }} Ft összegben van kiegyenlítetlen számlája
			</div>
		</div>
		<div
			class="col-12 col-sm-6 col-md-6 mt-2"
			v-if="rend_sel_customer != null && rend_sel_customer != ''"
		>
			<div class="row">
				<div class="col-12">
					<div class="h5">
						Kiválasztott partner
					</div>
				</div>
				<div class="col-12">
					<div class="h5">
						{{ rend_sel_customer != null && rend_sel_customer != '' ? rend_sel_customer.nev : '' }}
					</div>
				</div>
			</div>
		</div>
		<div
			class="col-12 col-sm-6 col-md-6"
			v-if="rend_sel_customer != null && rend_sel_customer != ''"
		>
			<router-link
				class="btn btn-outline-primary btn-lg m-2"
				:to="'/orders/new_order/products'"
			>
				Tovább a termékekhez
				<i class="fa fa-chevron-right fa-lg"></i>
			</router-link>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
	name: 'order_customer',
	
	data(){
		return {
			search: {
				nev: '',
				city: '',
				street: ''
			},
			customers: null,
			isLoading: false
		}
	},

	created() {
		this.$store.dispatch('setrendselcustomer',null)
		this.checkSearch = _.debounce(this.load, 500)
  	},
  	
	methods: {
		load() {
			this.customers = null
			this.$Progress.start()
			this.isLoading = true
			this.req.post('/customers/search/neworder',{
				search: {
					nev: this.search.nev,
					cim: this.search.street,
					varos: this.search.city
				}
			})
			.then(res => {
				this.customers = res.data.customers
			  	this.$Progress.finish()
			  	this.isLoading = false
			})
			.catch(err => {
				console.error(err)
				toastr.error(err.response.data.text || err)
				this.$Progress.fail()
				this.isLoading = false
			})
		}
	},

	computed: {
		...mapGetters(['rend_sel_customer'])
	},

	watch: {
	    search: {
	    	handler(newValue,oldValue) {
	    		this.checkSearch()
	    	},
	    	deep: true
	    }
	}
}
</script>


// WEBPACK FOOTER //
// src/components/orders/new_order/order_customer.vue